module.exports = __webpack_public_path__ + "img/icon_leave_blue.98bc1a22.svg";